import { products } from "../data/productData";
import { isProductVisible } from "../utils/productFilters";

const toSlug = (value) =>
  value
    .toLowerCase()
    .trim()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const titleize = (value) =>
  value.replace(/\b\w/g, (char) => char.toUpperCase());

const categoryDescriptions = {
  skincare:
    "Brightening creams, body butters, serums and soap formulas designed to hydrate, smooth and restore glow.",
  haircare:
    "Hair growth oils and nourishing care essentials focused on moisture, scalp health and healthy-looking shine.",
  "scrub-set":
    "Professional scrub sets built for comfort, movement and everyday wear in clinical settings.",
  beauty:
    "Beauty staples and personal care pieces that complement your daily skincare and self-care routine.",
  "lash-supplies":
    "Lash adhesives and lash-focused beauty accessories for clean application and long-wear performance.",
  "medical-supplies":
    "Disposable gloves, masks and practical supplies curated for hygiene, routine care and workplace use.",
};

const categoryHeroTitles = {
  skincare: "Skincare Collection",
  haircare: "Haircare Collection",
  "scrub-set": "Clinical Scrub Sets",
  beauty: "Beauty Essentials",
  "lash-supplies": "Lash Supplies",
  "medical-supplies": "Medical Supplies",
};

const categoryMap = new Map();

products.forEach((product) => {
  const rawName = product.mainCategories || product.category || "collection";
  const slug = toSlug(rawName);

  if (!categoryMap.has(slug)) {
    categoryMap.set(slug, {
      slug,
      name: rawName,
      title: categoryHeroTitles[slug] || titleize(rawName),
      description:
        categoryDescriptions[slug] ||
        `Explore JmoLux ${rawName} products curated for quality, comfort and daily use.`,
    });
  }
});

export const categoryList = Array.from(categoryMap.values()).sort((a, b) =>
  a.title.localeCompare(b.title)
);

export const getCategoryBySlug = (slug) =>
  categoryList.find((category) => category.slug === slug);

export const getProductsByCategorySlug = (slug) =>
  products.filter(
    (product) =>
      isProductVisible(product) &&
      toSlug(product.mainCategories || product.category || "") === slug,
  );

export const getCategoryCount = (slug) => getProductsByCategorySlug(slug).length;
